import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Layout } from '../components/Layout'
import { RequireAuth } from '../auth/RequireAuth'
import { SignInPage } from '../pages/SignInPage'
import { AccessRevokedPage } from '../pages/AccessRevokedPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { EventsPage } from '../pages/EventsPage'
import { EventFormPage } from '../pages/EventFormPage'
import { PlanCreatePage } from '../pages/PlanCreatePage'
import { EventDetailPage } from '../pages/EventDetailPage'
import { MyWorkPage } from '../pages/MyWorkPage'
import { NotificationPreferencesPage } from '../pages/NotificationPreferencesPage'
import { TemplatesPage } from '../pages/TemplatesPage'
import { TimelineTemplateEditorPage } from '../pages/TimelineTemplateEditorPage'
import { ChecklistTemplateEditorPage } from '../pages/ChecklistTemplateEditorPage'
import { UsersPage } from '../pages/UsersPage'

export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  { path: '/access-revoked', element: <AccessRevokedPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/events" replace /> },
      { path: 'events', element: <EventsPage /> },
      {
        path: 'events/new',
        element: (
          <RequireAuth role="Coordinator">
            <EventFormPage />
          </RequireAuth>
        ),
      },
      { path: 'events/:eventId', element: <EventDetailPage /> },
      {
        path: 'events/:eventId/plan/new',
        element: (
          <RequireAuth role="Coordinator">
            <PlanCreatePage />
          </RequireAuth>
        ),
      },
      {
        path: 'events/:eventId/edit',
        element: (
          <RequireAuth role="Coordinator">
            <EventFormPage />
          </RequireAuth>
        ),
      },
      { path: 'my-work', element: <MyWorkPage /> },
      { path: 'settings/notifications', element: <NotificationPreferencesPage /> },
      {
        path: 'templates',
        element: (
          <RequireAuth role="Coordinator">
            <TemplatesPage />
          </RequireAuth>
        ),
      },
      {
        path: 'templates/timeline/:templateId',
        element: (
          <RequireAuth role="Member">
            <TimelineTemplateEditorPage />
          </RequireAuth>
        ),
      },
      {
        path: 'templates/checklist/:templateId',
        element: (
          <RequireAuth role="Member">
            <ChecklistTemplateEditorPage />
          </RequireAuth>
        ),
      },
      {
        path: 'users',
        element: (
          <RequireAuth role="Admin">
            <UsersPage />
          </RequireAuth>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
